module.exports = __webpack_public_path__ + "static/img/thesaurus-no-results.d319440.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thesaurus-no-results.svg
// module id = dxHA
// module chunks = 10